import { File, FilePdf, FileImage, FileDoc } from '@phosphor-icons/react';

/**
 * FileIcon - Displays appropriate icon based on content type
 */
export const FileIcon = ({ contentType, className = "w-8 h-8" }) => {
    if (contentType?.startsWith('image/')) {
        return <FileImage className={`${className} text-purple-500`} />;
    }
    if (contentType === 'application/pdf') {
        return <FilePdf className={`${className} text-red-500`} />;
    }
    if (contentType?.includes('word') || contentType?.includes('document')) {
        return <FileDoc className={`${className} text-blue-500`} />;
    }
    return <File className={`${className} text-gray-500`} />;
};

export default FileIcon;
